<template>
  <div id="container">
    <div id="main">
      <header class="home-header">
        <nav-bar/>
      </header>
      <div class="swiper-container">
        <!-- 添加导航按钮 -->
        <swiper :list="swiperList"></swiper>
      </div>
      <div class="group-intro">
        <div class="group-title">
          <h1>
            <span style="color: #3895bf" >SAIL </span> - Short Introduction
          </h1></div>
        <div>
          <p class="group-desc">
    The SAIL (SEU AI-native IoT Lab) is a laboratory founded by Professor He Tian and Professor Wang Shuai in November 2018. The research directions of the laboratory include: Embodied AI Perception and Interaction, Embodied AI Decision-Making and Time-Series Data Analysis and Embodied AI Systems and Continuous Evolution, etc. At present, there are 11 doctoral students and more than 40 master students, and have carried out joint student training work with many internationally renowned universities/enterprises such as University of Minnesota, Rutgers University, Wayne State University, City University of Hong Kong, Ele.me, and JD Logistics.
          </p>
        </div>
      </div>
      <div class="research-list">
        <!--这里的goTo语句只能定向的转到其他小标签-->
        <div v-for="(research, index) in researchList" v-bind:key="research.index" :class="['research-card', research.themeClass]" @click="goTo">
          <div class="research-copy">
            <em>Research Area {{ `0${index + 1}` }}</em>
            <router-link tag="a" to="/publication/topic"><span>{{ research.name }}</span></router-link>
          </div>
          <div :class="['research-image', research.imageClass]">
            <img :src="research.imgUrl" alt="">
          </div>
        </div>
      </div>

      <div class="prof-list">
        <div v-for="prof in professorList" v-bind:key="prof.index" class="card">
          <div>
            <img :src="prof.imgUrl">
          </div>
          <div class="col">
            <a :href="prof.pageUrl"><span>{{ prof.name }}</span></a>
            <el-divider></el-divider>
            <p v-html="prof.desc"></p>
            <br/>
            <br/>
            <p v-html="'<b>Research Interests:   </b>' + prof.resIn"></p>
          </div>
        </div>
      </div>

    </div>
    <footerInfo/>
  </div>
</template>

<script>
import swiper from '@/components/Swiper'
import navBar from '@/components/NavBar'
import footerInfo from '@/components/FooterInfo'
import {getLocal} from '@/common/js/utils'
import {Toast} from 'vant'

export default {
  name: 'home',

  data() {
    return {
      swiperList: [],
      isLogin: false,
      headerScroll: true,
      researchList: [{
        'name': 'Embodied AI Perception and Interaction',
        'imgUrl': require('../assets/research/sensing.jpg'),
        'imageClass': 'is-standard',
        'themeClass': 'theme-orange',
        'desc': '互联的移动和嵌入式设备的激增带来了一个传感器丰富的世界。在我们的日常环境中，越来越多的事物具有计算、传感和通信功能，这种功能有望彻底改变人类与物理对象之间的交互。通过智能感知与数据采集，可获得大规模传感数据供信息特征挖掘。同时，深度学习的最新进展极大地改变了计算设备处理以人为中心的内容（例如图像，视频，语音和音频）的方式。因此，将深层神经网络应用于IoT设备采集的数据挖掘可以能够执行复杂的感测和识别任务，以支持人类与其周围环境之间相互作用的新领域。'


      }
        , {
          'name': 'Embodied AI Decision-Making and Time-Series Data Analysis',
          'imgUrl': require('../assets/research/bigdata.jpg'),
          'imageClass': 'is-standard',
          'themeClass': 'theme-blue',
          'desc': '实验室基于数据驱动去研究并解决实际生活中的许多问题，如停车场空闲车位的有效分配、即时配送场景的订单分派、共享单车的平衡调度、蜂窝数据的用量预测等。'
        }, {
          'name': 'Embodied AI Systems and Continuous Evolution',
          'imgUrl': require('../assets/research/tongxin.jpg'),
          'imageClass': 'is-wide',
          'themeClass': 'theme-green',
          'desc': '物联网设备数量正在以一个飞快的速度增长，如何更加智能化地连接、使用这些设备成为了一个非常具有科研和应用价值的方向。研究计算机视觉与物联网设备结合的技术，利用不同传感器收集的数据进行融合从而解决某些场景下相应的问题等。'

        }],
      professorList: [
        {
          'id': 1,
          'name': 'SHUAI WANG',
          'imgUrl': require('../assets/people/wangshuai.jpg'),
          'pageUrl': 'https://cs.seu.edu.cn/shuaiwang/main.htm',
          'desc': '<b>Young Chief Professor</b>, School of Computer Science and Engineering, Southeast University<br/>' +
              '<b>Executive Director</b>, Smart Internet of Things Research Center, Southeast University',
          'resIn': 'Embodied AI'
        },
        {
          'id': 2,
          'name': "SHUAI WANG",
          'imgUrl': require("../assets/people/xiaoshuai.jpg"),
          'pageUrl': "https://cs.seu.edu.cn/shuaiwang_iot/main.htm",
          'desc': '<b>Professor</b>, School of Computer Science and Engineering, Southeast University',
          'resIn': 'Embodied AI Perception and Interaction'
        },
        {
          'id': 3,
          'name': 'LI LIN',
          'imgUrl': require('../assets/people/linli.jpeg'),
          'pageUrl': 'https://veralily.github.io/',
          'desc': '<b>Lecturer</b>, School of Computer Science and Engineering, Southeast University',
          'resIn': 'Embodied AI Decision-Making and Time-Series Data Analysis'
        }, {
          'id': 4,
          'name': 'BORUI LI',
          'imgUrl': require('../assets/people/liborui.png'),
          'pageUrl': 'https://www.liborui.cn/',
          'desc': '<b>Lecturer</b>, School of Computer Science and Engineering, Southeast University',
          'resIn': 'Embodied AI Systems and Continuous Evolution'
        }
      ],
    }
  },
  components: {
    navBar,
    swiper,
    footerInfo,
  },
  async mounted() {
    const token = getLocal('token')
    if (token) {
      this.isLogin = true
    }
    window.addEventListener('scroll', this.pageScroll)
    Toast.loading({
      message: '加载中...',
      forbidClick: true
    });
    this.swiperList = [
      {
        "carouselUrl": require("../assets/building2.jpg"),
      },
      {
        "carouselUrl": require("../assets/students2.jpg"),
      },
      {
        "carouselUrl": require("../assets/students3.jpg"),
      },
      {
        "carouselUrl": require("../assets/students4.jpg"),
      },
      {
        "carouselUrl": require("../assets/students5.jpg"),
      }]
    Toast.clear()
  },
  methods: {
    pageScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      scrollTop > 100 ? this.headerScroll = true : this.headerScroll = false
    },
    goTo() {
      this.$router.push({path: `publication/topic`})
    },

    goToUrl(url) {
      window.location.href = url;
    }
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';
@import '../common/style/text';

.swiper-container {
  padding-top: 10vh;
  width: 100%;
  height: 56.25vw; /* 默认16:9比例 (9/16=0.5625) */
  max-height: 80vh; /* 最大高度限制 */
  position: relative;
  overflow: hidden;

  ::v-deep .swiper-slide {
    position: relative;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      vertical-align: middle;
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) { /* 移动端 */
  .swiper-container {
    height: 75vw;   /* 4:3 比例 */
    max-height: 70vh;
  }
}

@media (min-width: 1200px) { /* 大屏 */
  .swiper-container {
    max-height: 720px; /* 限制最大高度 */
  }
}

/* 保持宽高比备用方案（现代浏览器） */
@supports (aspect-ratio: 16/9) {
  .swiper-container {
    height: auto;
    aspect-ratio: 16/9;
    max-height: 80vh;

    @media (max-width: 768px) {
      aspect-ratio: 4/3;
    }
  }
}

@media (max-width: 768px) {
  .research-list {
    width: calc(100% - 32px);
    gap: 16px;
    padding: 12px 0 10px;

    .research-card {
      width: 100%;
      min-height: auto;
    }
  }
}

@media (min-width: 1200px) {
  .research-list {
    .research-card {
      width: calc((100% - 48px) / 3);
    }
  }
}

#container {
  position: relative;
}
#main {
  padding-bottom: 150px;
}

.home-header {
  position: fixed;
  left: 0;
  top: 0;
  .wh(100%, 40px);
  .fj();
  line-height: 40px;
  .boxSizing();
  font-size: 12px;
  color: #fff;
  z-index: 10000;
  box-shadow: 0 0 4px 0 @theme-color;
}

.group-intro {
  display: flex;
  width: 100%;
  padding-bottom: 13px;
  flex-direction: column;
  color: #000;

  .group-title {
    .wh(100%, 40px);
    text-align: center;
    font-weight: bolder;
    font-size: 20px;
    margin: 10px 0 30px 0;
  }

  .group-desc {
    padding: 15px 15%;
    text-align: justify;
    color: #4d5156;
    font-weight: 500;
    font-size: 15px;
    line-height: 25px;
  }

}

.research-list {
  display: flex;
  width: 70%;
  margin: 0 auto;
  flex-wrap: wrap;
  flex-direction: row;
  .fj(center);
  gap: 24px;
  padding: 18px 0 10px;
  box-sizing: border-box;

    .research-card {
      width: calc((100% - 48px) / 3);
      min-height: 382px;
    color: #4d5156;
    background: linear-gradient(180deg, #fdfefe 0%, #f4f8fc 100%);
    flex-direction: column;
    display: flex;
    margin: 0;
    padding: 16px;
    border-radius: 24px;
    border: 1px solid #dde7f0;
    box-shadow: 0 18px 40px rgba(16, 42, 67, 0.10);
    box-sizing: border-box;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    overflow: hidden;
    position: relative;

      &::before {
        content: '';
        position: absolute;
        inset: 0 0 auto 0;
        height: 112px;
        background: linear-gradient(135deg, rgba(43, 119, 184, 0.18), transparent 72%);
        pointer-events: none;
      }

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 24px 48px rgba(16, 42, 67, 0.16);
    }

    img {
      display: block;
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      transition: transform 0.28s ease;
    }

      .research-copy {
        min-height: 96px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px;
        padding: 4px 6px 0;
        margin-bottom: 8px;
        position: relative;
        z-index: 1;
        text-align: left;
      }

    em {
      display: inline-flex;
      align-items: center;
      width: fit-content;
      padding: 6px 11px;
      border-radius: 999px;
      font-style: normal;
      font-size: 11px;
      line-height: 1;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #28556b;
      background: rgba(255, 255, 255, 0.8);
      border: 1px solid rgba(56, 149, 191, 0.18);
    }

      .research-image {
        width: 100%;
        height: 224px;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 14px;
        overflow: hidden;
        background:
          linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(246, 250, 253, 0.98)),
        radial-gradient(circle at top, rgba(56, 149, 191, 0.10), transparent 55%);
      border: 1px solid #e5edf4;
      border-radius: 18px;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9), 0 8px 18px rgba(28, 53, 77, 0.06);
      box-sizing: border-box;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .research-image.is-wide {
        height: 220px;
        padding: 10px 12px;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .research-image.is-standard {
        height: 224px;
      }

    a {
      min-height: 0;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      padding: 0;
      margin: 0;
      text-align: left;

      :hover {
        color: @theme-color;
      }
    }

    span {
      font-size: 16px;
      line-height: 1.24;
      font-weight: 700;
      text-align: left;
      color: #18364a;
      max-width: 94%;
    }

    p {
      padding: 10px 10px;
      font-size: 12px;
      text-align: left;
    }

    &:hover .research-image img {
      transform: scale(1.03);
    }
  }

  .research-card.theme-blue::before {
    background: linear-gradient(135deg, rgba(43, 119, 184, 0.20), transparent 72%);
  }

  .research-card.theme-green::before {
    background: linear-gradient(135deg, rgba(62, 148, 120, 0.20), transparent 72%);
  }

  .research-card.theme-orange::before {
    background: linear-gradient(135deg, rgba(214, 138, 61, 0.22), transparent 72%);
  }
}

.prof-list {
  display: flex;
  width: 100%;
  padding-top: 15px;
  flex-direction: column;
  .fj(center);
  padding-bottom: 15px;
  justify-content: center;
  align-items: center;

  .card {
    width: 72%;
    //margin-left: 15%;

    margin-bottom: 15px;

    color: #4d5156;
    background-color: #fefefe;

    flex-direction: row;
    text-align: center;
    .fj(space-around);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);


    img {
      .wh(100px, 120px);
      border-radius: 8px;
      margin: 20px 0;
    }

    &:hover {
      background-color: #fff;
    }

    .col {
      width: 80%;
      color: #4d5156;
      background-color: #fefefe;
      margin: 20px 0;
      flex-direction: column;
      text-align: left;
      //.fj(center);

      a {
        padding-top: 10px;


        :hover {
          color: @theme-color;
        }
      }

      span {
        padding-left: 10px;
        margin-top: 10px;
        font-size: 15px;
        font-weight: bold;
      }

      p {
        //padding: 0px 10px;
        margin: 0 10px;
        font-size: 12px;
        text-align: justify;
        line-height: 20px;
      }
    }

  }

}

.professor-desc {
  margin: auto;
  width: 72%;
  //margin-top: 15px;
  padding-bottom: 15px;
}
.el-row {
  margin-top: 20px;

}


.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 2px dashed rgba(56, 149, 191, 0.25);
}

.el-card {
  margin: 0;
  width: 90%;
  border: 0ch;

}


.image {
  width: 90%;
  display: block;
}

</style>
